<template>
</template>

<script>

  import piincHttp from '@/util/configureAxios.js'

  export default {
    name: 'Token',
    data() {
      return {

      };
    },
    components: {

    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getHistoryPage() {
        return this.$store.state.historyPage
      }
    },
    methods: {

    },
    created() {
      let self = this;
      // Component accessed when going on route: base_url/token/{token}
      // We are taking the token and logging users in, and after that, redirecting to homepage
      if (this.$route.params.token) {
        if (this.$route.params.token == 'invalid') {
          setTimeout(function() {
            self.$router.push({name: 'login', params: {error: true}})
          }, 300)

        } else {
          localStorage.setItem('token', this.$route.params.token);
          piincHttp.defaults.headers.common['Authorization'] = this.$route.params.token;
          setTimeout(function() {
            if (self.getHistoryPage && self.getHistoryPage != '') {
              window.location.href = self.getHistoryPage;
            } else {
              window.location.href = '/';
            }
          }, 300)
        }
      }
    }
  }

</script>
